// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-button {
    display: inline-flex;
    align-items: center;
    transition: border-color 0.3s ease;
}

@media (hover: none) and (pointer: coarse) {
    .modal-button:hover {
        background-color: var(--color-component-background);
        color: var(--color-component-foreground);
        stroke: var(--color-component-foreground);
        fill: var(--color-component-foreground);
    }
}

.modal-button.active {
    background-color: var(--color-component-hover-back);
    color: var(--color-component-hover-fore);
    stroke: var(--color-component-hover-fore);
    fill: var(--color-component-hover-fore);
}

    .modal-button-icon-only {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .modal-button-with-title {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
    }

    .modal-button-title {
        
    }

    .modal-button-close-wrapper {
        display: flex;
        justify-content: flex-end;
        padding: 0.5rem;
    }

    .modal-button-close {
        background: none;
        border: none;
        font-size: 1.6rem;
        cursor: pointer;
        line-height: 1;
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/Button/css/ModalButton.css"],"names":[],"mappings":"AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI;QACI,mDAAmD;QACnD,wCAAwC;QACxC,yCAAyC;QACzC,uCAAuC;IAC3C;AACJ;;AAEA;IACI,mDAAmD;IACnD,wCAAwC;IACxC,yCAAyC;IACzC,uCAAuC;AAC3C;;IAEI;QACI,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,WAAW;IACf;;IAEA;;IAEA;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,cAAc;IAClB","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.modal-button {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    transition: border-color 0.3s ease;\r\n}\r\n\r\n@media (hover: none) and (pointer: coarse) {\r\n    .modal-button:hover {\r\n        background-color: var(--color-component-background);\r\n        color: var(--color-component-foreground);\r\n        stroke: var(--color-component-foreground);\r\n        fill: var(--color-component-foreground);\r\n    }\r\n}\r\n\r\n.modal-button.active {\r\n    background-color: var(--color-component-hover-back);\r\n    color: var(--color-component-hover-fore);\r\n    stroke: var(--color-component-hover-fore);\r\n    fill: var(--color-component-hover-fore);\r\n}\r\n\r\n    .modal-button-icon-only {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .modal-button-with-title {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 0.5rem;\r\n    }\r\n\r\n    .modal-button-title {\r\n        \r\n    }\r\n\r\n    .modal-button-close-wrapper {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        padding: 0.5rem;\r\n    }\r\n\r\n    .modal-button-close {\r\n        background: none;\r\n        border: none;\r\n        font-size: 1.6rem;\r\n        cursor: pointer;\r\n        line-height: 1;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
